var _path, _mask, _rect, _mask2, _rect2, _mask3, _rect3, _mask4, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWheelAligemnt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.58 2.684h7.157M3.58 14.316h7.157M7.158 2.684v11.632",
    stroke: "#e95832",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "wheel_aligemnt_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.737,
    width: 3.579,
    height: 5.368,
    rx: 0.895
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.737,
    width: 3.579,
    height: 5.368,
    rx: 0.895,
    stroke: "#e95832",
    strokeWidth: 3,
    mask: "url(#wheel_aligemnt_svg__a)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "wheel_aligemnt_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.737,
    y: 11.632,
    width: 3.579,
    height: 5.368,
    rx: 0.895
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.737,
    y: 11.632,
    width: 3.579,
    height: 5.368,
    rx: 0.895,
    stroke: "#e95832",
    strokeWidth: 3,
    mask: "url(#wheel_aligemnt_svg__b)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "wheel_aligemnt_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.579,
    height: 5.368,
    rx: 0.895
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3.579,
    height: 5.368,
    rx: 0.895,
    stroke: "#e95832",
    strokeWidth: 3,
    mask: "url(#wheel_aligemnt_svg__c)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "wheel_aligemnt_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 11.632,
    width: 3.579,
    height: 5.368,
    rx: 0.895
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 11.632,
    width: 3.579,
    height: 5.368,
    rx: 0.895,
    stroke: "#e95832",
    strokeWidth: 3,
    mask: "url(#wheel_aligemnt_svg__d)"
  })));
}
export default __webpack_public_path__ + "static/media/wheel_aligemnt.4c5925fc.svg";
export { SvgWheelAligemnt as ReactComponent };